import { AuthAPIErrorCodeEnum } from '@/features/api/auth/constants'
import { MasterAPIErrorCodeEnum } from '@/features/api/master/constants'
import { OAuthErrorTypeEnum } from '@/features/api/oauth/constants'
import { ThunkRejectValue } from '@/redux/types'
import { HttpStatusCode } from 'axios'

export const getAuthLicenceErrorTranslation = (error: ThunkRejectValue) => {
    if (error.expectedApiError?.identifier === MasterAPIErrorCodeEnum.EntityNotFound.toString()) {
        return 'licenceVerificationScreenEntityNotFound' as const
    }

    if (error.expectedApiError?.status === HttpStatusCode.InternalServerError) {
        return 'serverError' as const
    }

    return 'unexpectedError' as const
}

export const getAuthDeviceErrorTranslation = (error: ThunkRejectValue) => {
    if (error.expectedApiError?.identifier === AuthAPIErrorCodeEnum.NotGranted.toString()) {
        return 'deviceAuthorizationScreenErrorNotGranted' as const
    }

    if (error.expectedApiError?.status === HttpStatusCode.InternalServerError) {
        return 'serverError' as const
    }

    return 'unexpectedError' as const
}

export const getAuthProfilePinErrorTranslation = (error: ThunkRejectValue) => {
    if (error.expectedApiError?.identifier === OAuthErrorTypeEnum.InvalidClient) {
        return {
            title: 'profilePinScreenInvalidClientError.title',
            message: 'profilePinScreenInvalidClientError.message',
        } as const
    }

    if (error.expectedApiError?.identifier === OAuthErrorTypeEnum.InvalidGrant) {
        return { message: 'profilePinScreenInvalidGrantError' } as const
    }

    if (error.expectedApiError?.status === HttpStatusCode.InternalServerError) {
        return { message: 'serverError' } as const
    }

    return { message: 'unexpectedError' } as const
}
